module.exports = __webpack_public_path__ + "static/media/projects4.662452cc.jpg";